import { render, staticRenderFns } from "./RetoursClosedTable.vue?vue&type=template&id=d7be7036&scoped=true&lang=true&"
import script from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
export * from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
import style0 from "./RetoursClosedTable.vue?vue&type=style&index=0&id=d7be7036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7be7036",
  null
  
)

export default component.exports